/** Validate the terrain-relative height used only for rendering building boxes. */
export const getBuildingDisplayHeight = (
  value: unknown
): number | undefined => {
  if (typeof value !== 'number' && typeof value !== 'string') return undefined
  const height = Number(value)
  return Number.isFinite(height) && height > 0 ? height : undefined
}

/** Prefer the display height without changing a layer's existing fallback chain. */
export const withBuildingDisplayHeight = (fallback: unknown): unknown[] => [
  'let',
  'displayHeight',
  [
    'match',
    ['typeof', ['get', 'height_estimate_to_display']],
    ['number', 'string'],
    ['to-number', ['get', 'height_estimate_to_display'], 0],
    0,
  ],
  [
    'case',
    [
      'all',
      ['>', ['var', 'displayHeight'], 0],
      ['<=', ['var', 'displayHeight'], Number.MAX_VALUE],
    ],
    ['var', 'displayHeight'],
    fallback,
  ],
]
